module.exports = __webpack_public_path__ + "static/image5-c5c4dedaf8cf6ed7807ffeef8ec4fb86.jpeg";